import React, { useState } from 'react'
import {
  CouponButton,
  CouponError,
  CouponInput,
  CouponInputWrapper,
  CouponTitle,
  CouponWrapper,
  ValidCoupon,
} from 'Features/checkout/components/Coupon/Coupon.styled'
import { useTranslation } from 'react-i18next'
import { useValidateCoupon } from 'Features/checkout/api/validateCoupon'
import { COUPON_DURATION, COUPON_TYPE } from '../CheckoutPlanDetails/CheckOutPlanDetails.model'

interface CouponProps {
  onValidateCoupon: (couponObject: CouponType) => void
  currency: string
  isMonthlyBilling: boolean
}
export interface CouponType {
  amount: number
  currency: string
  couponType: string
  valid: boolean
  code: string
  duration: string
}
export const Coupon = ({ onValidateCoupon, currency, isMonthlyBilling }: CouponProps) => {
  const { t } = useTranslation('checkout')
  const [couponValue, setCouponValue] = useState<string>('')
  const { mutate: validateCoupon } = useValidateCoupon()
  const [validCoupon, setValidCoupon] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  const defaultCouponObject = {
    amount: 0,
    currency: '',
    couponType: '',
    valid: false,
    code: '',
    duration: '',
  }

  const handleValidateCoupon = () => {
    if (couponValue) {
      validateCoupon(couponValue, {
        onSettled(data) {
          if (!(data instanceof Error) && data?.data.valid) {
            setError('')
            setValidCoupon(true)
            const couponDataWithCode = {
              ...data.data,
              code: couponValue,
            }
            if (data.data.couponType === COUPON_TYPE.Fixed && currency !== data.data.currency) {
              setError(t('coupon_currency_mismatch'))
              setValidCoupon(false)
              onValidateCoupon(defaultCouponObject)
            } else if (
              isMonthlyBilling &&
              (data.data.couponType !== COUPON_TYPE.Percentage ||
                data.data.duration !== COUPON_DURATION.Forever)
            ) {
              setError(t('coupon_redemption_installment_subscription_error'))
              setValidCoupon(false)
              onValidateCoupon(couponDataWithCode)
            } else {
              onValidateCoupon(couponDataWithCode)
            }
          } else {
            setValidCoupon(false)
            setError(t('coupon_error'))
            onValidateCoupon(defaultCouponObject)
          }
        },
      })
    }
  }
  return (
    <CouponWrapper>
      <CouponTitle>{t('have_a_coupon')}</CouponTitle>
      <CouponInputWrapper>
        <CouponInput
          placeholder={t('enter_coupon_placeholder')}
          value={couponValue}
          onChange={(e) => {
            setCouponValue(e.target.value)
          }}
        />
        <CouponButton
          text={t('apply_coupon')}
          onClick={() => {
            handleValidateCoupon()
          }}
          variant={'outline'}
        />
      </CouponInputWrapper>
      {!!error && <CouponError>{error}</CouponError>}
      {validCoupon && <ValidCoupon>{t('coupon_success')}</ValidCoupon>}
    </CouponWrapper>
  )
}
